import { api, getAuthToken } from './api';

// Fire-and-forget analytics — never blocks UI, never throws
export function track(eventType, meta = {}) {
  try {
    const token = getAuthToken();
    const payload = {
      event_type: eventType,
      route: window.location.pathname,
      meta
    };
    // Use sendBeacon for page unload events, fetch for others
    if (eventType === 'page_view') {
      api.post('/analytics/track', payload).catch(() => {});
    } else {
      api.post('/analytics/track', payload).catch(() => {});
    }
  } catch {}
}

// Track page views on route change
export function trackPageView(path) {
  track('page_view', { path: path || window.location.pathname });
}
